import { choose, confirm } from '../components/Dialog';

// Clock out (Lj, Oct 9): on a task, first ask whether it's done — Yes finishes it (its running time banked onto it),
// No leaves it open — then clock out. Not on a task: the plain "Clock out?" as before. Cancel = stay on the clock.
export async function askAndClockOut({ tasks = [], activeTaskId = null, completeTask, clockOut }) {
  const t = activeTaskId ? tasks.find((x) => x.id === activeTaskId && x.status !== 'done' && !x.bucket) : null;
  if (!t) {
    if (await confirm({ title: 'Clock out?', message: 'Ends the clock and the running task timer.', icon: 'stop-circle', confirmLabel: 'Clock out' })) await clockOut();
    return;
  }
  const v = await choose({
    title: 'Clock out', eyebrow: 'Before you go', icon: 'stop-circle', message: `Is “${t.title}” done?`,
    options: [{ label: 'No, keep it open', value: 'no' }, { label: 'Yes, it’s done', value: 'yes', primary: true }],
  });
  if (v == null) return;
  if (v === 'yes') await completeTask(t.id);
  await clockOut();
}
